<template>
  <div>
    <el-dialog
      center
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="handleClose"
      @open="GetRequestTasksData"
    >
      <rabbey-table-3
        :border="true"
        :stripe="true"
        :actions="TaskActions"
        @rtable-push-action="handlePushAction"
        :loading="loadingData"
        :data="FilteredTasks"
        :columns="TaskColumns"
        show-summary
        sum-text="Tiempo Total"
        :summary-method="getSummaries"
        page_Size="500"
        :pageSizes="[500, 1000]"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cerrar</el-button>
        <!-- <el-button type="primary" @click="dialogVisible = false">Confirmar</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TasksAndRequestColumns } from "@/columns/ProductiveHoursReportByMonths/ProductiveHoursReportByMonths";
import { TasksAndRequestsActions } from "../../../columns/ProductiveHoursReportByMonths/ProductiveHoursReportByMonths";

export default {
  name: "ProductivityByMonthsTasksAndRequestsList",
  props: {
    dialogVisibleProp: {
      type: Boolean,
      required: true
    },
    rowData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    ColumnData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    filters: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      MonthsInSpanish: {
        January: "Enero",
        February: "Febrero",
        March: "Marzo",
        April: "Abril",
        May: "Mayo",
        June: "Junio",
        July: "Julio",
        August: "Agosto",
        September: "Septiembre",
        October: "Octubre",
        November: "Noviembre",
        December: "Diciembre"
      },
      MonthsInNumbers: {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12
      },

      TaskActions: TasksAndRequestsActions,
      loadingData: false,
      TaskColumns: TasksAndRequestColumns,
      TaskData: []
    };
  },
  computed: {
    dialogVisible() {
      return this.dialogVisibleProp;
    },
    dialogTitle() {
      let title = "";
      switch (this.filters.Type) {
        case "SI": {
          title = "Solicitudes Internas";
          break;
        }
        case "SE": {
          title = "Solicitudes Externas";
          break;
        }
        case "TE": {
          title = "Tareas Estratégicas";
          break;
        }
        case "TO": {
          title = "Tareas Operacionales";
          break;
        }
        default: {
          title = "Solicitudes y Tareas";
          break;
        }
      }
      return `${title} del mes de ${
        this.MonthsInNumbers[this.ColumnData.property]
      }`;
    },
    FilteredTasks() {
      return this.TaskData;
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit("CloseTaskListDialog", false);
    },
    async GetRequestTasksData() {
      this.loadingData = true;

      await this.$http
        .get(
          "/api/ReporteGestion/Get_Detailed_List_Of_Productive_Hours_Report_By_Month",
          {
            params: {
              ResponsableID: this.rowData.ResponsableID,
              DirecctionID: this.filters.Direction,
              DeparmentId: this.filters.Deparment,
              Year: this.filters.Year,
              Month: this.MonthsInNumbers[this.ColumnData.property],
              WeekOnMothSelected: this.filters.Week,
              Type: this.filters.Type
            }
          }
        )
        .then((response) => {
          this.TaskData = response.data;
          this.loadingData = false;
        })
        .catch(() => {
          this.loadingData = false;
          this.$message.error("Error al cargar los datos de las tareas.");
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    handlePushAction() {},
    getSummaries() {}
  }
};
</script>

<style lang="scss" scoped></style>
